import { render } from "./SubMenuBar.vue?vue&type=template&id=e2e790ee&scoped=true&ts=true"
import script from "./SubMenuBar.vue?vue&type=script&lang=ts"
export * from "./SubMenuBar.vue?vue&type=script&lang=ts"

import "./SubMenuBar.vue?vue&type=style&index=0&id=e2e790ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e790ee"]])

export default __exports__